module.exports = __webpack_public_path__ + "static/media/rotate_reversed.b96bff8c.png";